import Vue from "vue";
import * as MutationsType from "./mutationsType";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.SET_CATEGORY](state, payload) {
    state.category = payload;
  },
  [MutationsType.SET_CATEGORIES](state, payload) {
    state.categories = payload;
  },
  [MutationsType.ADD_CATEGORY](state, payload) {
    if (state.categories) state.categories.unshift(payload);
  },
  [MutationsType.UPDATE_CATEGORY](state, payload) {
    let ind = (state.categories || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.categories, ind, payload);
  },
  [MutationsType.DETELE_CATEGORY](state, payload) {
    let ind = (state.categories || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) state.categories.splice(ind, 1);
  },
};
